import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography
} from '@material-ui/core'
import clsx from 'clsx'
import { ROUTES } from 'routes'
import { SectionLayoutDialog } from 'shared'
import { updateEvent } from 'state/modules/events'

import { useStyles } from './ModalityEventDialog.style'

const EVENT_MODALITY_STATES = {
  FREE_MODALITY: {
    value: 'Free',
    label: 'GRATIS'
  },
  PAY_MODALITY: {
    value: 'Pay',
    label: 'PAGO'
  }
}

const EventModalityDialog = ({ open, onClose }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()

  const [eventModalityValue, setEventModalityValue] = useState(
    EVENT_MODALITY_STATES.FREE_MODALITY.value
  )

  const { event, updateEventPending } = useSelector((state) => state.events)

  const handleChange = (e) => {
    setEventModalityValue(e.target.value)
  }

  const handleUpdateEventState = async () => {
    const updateSuccess = await dispatch(
      updateEvent({
        ...event,
        isFree: eventModalityValue === EVENT_MODALITY_STATES.FREE_MODALITY.value
      })
    )

    if (!updateSuccess) return

    onClose()
    history.push(`${ROUTES.EVENTS.INSCRIPTION}/${event.slugUrl}`)
  }

  return (
    <SectionLayoutDialog
      title='MODALIDAD DE EVENTO'
      open={open}
      onClose={onClose}
      className={classes.dialog}>
      <FormControl component='fieldset'>
        <RadioGroup
          aria-label='gender'
          name='modalityEvent'
          value={eventModalityValue}
          onChange={handleChange}>
          <FormControlLabel
            value={EVENT_MODALITY_STATES.FREE_MODALITY.value}
            className={classes.formControlLabel}
            classes={{ label: classes.radioLabel }}
            control={<Radio color='primary' className={classes.radio} />}
            label={EVENT_MODALITY_STATES.FREE_MODALITY.label}
          />
          <FormLabel
            component='p'
            className={clsx(
              classes.label,
              eventModalityValue === EVENT_MODALITY_STATES.FREE_MODALITY.value && 'selected'
            )}>
            En esta modalidad, los tickets deben ser todos gratuitos, si tienes algún ticket con
            costo seleccioná la modalidad PAGO.
          </FormLabel>

          <FormControlLabel
            value={EVENT_MODALITY_STATES.PAY_MODALITY.value}
            className={classes.formControlLabel}
            classes={{ label: classes.radioLabel }}
            control={<Radio color='primary' className={classes.radio} />}
            label={
              <Typography className={classes.radioLabel}>
                {EVENT_MODALITY_STATES.PAY_MODALITY.label}
              </Typography>
            }
          />

          <FormLabel
            component='p'
            className={clsx(
              classes.label,
              eventModalityValue === EVENT_MODALITY_STATES.PAY_MODALITY.value && 'selected'
            )}>
            En esta modalidad, los tickets tienen un costo, aunque puedes ofrecer algunos tickets
            gratuitos.
          </FormLabel>
        </RadioGroup>
      </FormControl>

      <Button
        variant='contained'
        color='primary'
        className={classes.button}
        disabled={updateEventPending}
        endIcon={updateEventPending && <CircularProgress size={16} color='primary' />}
        onClick={handleUpdateEventState}>
        Aceptar
      </Button>
    </SectionLayoutDialog>
  )
}

export default EventModalityDialog
